import styled, { css } from 'styled-components';
import {} from './index.js';
import { getTypographyStyles, SEM_BORDER_RADIUS_UI_RADIUS_MAX, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_2400, SYS_SIZE_FIXED_600, SEM_TYPOGRAPHY_UI_SM_LABEL, SEM_TYPOGRAPHY_UI_MD_LABEL, getMargins } from '@oneaudi/unified-web-common';
export const StyledAvatar = styled.button `
  position: relative;
  margin: ${(props) => getMargins(props.margin)};
  padding: 0;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  border-radius: ${SEM_BORDER_RADIUS_UI_RADIUS_MAX};
  background-color: ${(props) => props.variant === 'logged-in'
    ? props.theme.cmp.color.ui.avatar.surface.fill.default
    : 'transparent'};
  // TODO: token missing;
  transition-property: background-color, color;
  transition-duration: 250ms;
  transition-timing-function: ease;
  color: ${(props) => props.variant === 'logged-in'
    ? props.theme.cmp.color.ui.avatar.foreground.text.secondary
    : props.theme.cmp.color.ui.avatar.foreground.text.default};

  ${(props) => {
    if (props.size === 'sm') {
        return css `
        height: ${SYS_SIZE_FIXED_600};
        width: ${SYS_SIZE_FIXED_600};
        ${getTypographyStyles(SEM_TYPOGRAPHY_UI_SM_LABEL)}
      `;
    }
    if (props.size === 'md') {
        return css `
        height: ${SYS_SIZE_FIXED_1200};
        width: ${SYS_SIZE_FIXED_1200};
        ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_LABEL)}
      `;
    }
    return css `
      height: ${SYS_SIZE_FIXED_2400};
      width: ${SYS_SIZE_FIXED_2400};
      // TODO: label should be LG, but no token exists for this yet.
      font-family: AudiType, sans-serif;
      letter-spacing: 0px;
      font-weight: 400;
      font-size: 24px;
      line-height: 30px;
      font-stretch: 105%;
    `;
}}

  &:disabled {
    cursor: not-allowed;
    ${(props) => props.image &&
    css `
        &::after {
          content: '';
          position: absolute;
          background-color: ${props.theme.cmp.color.ui.avatar.surface.fill
        .disabled};
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          /* TODO: add motion tokens */
          opacity: 0.7;
        }
      `}
  }

  ${(props) => props.variant === 'logged-in' &&
    css `
      &:hover:not(:disabled) {
        background-color: ${(props) => props.theme.cmp.color.ui.avatar.surface.fill.hover};
      }

      &:active:not(:disabled) {
        background-color: ${(props) => props.theme.cmp.color.ui.avatar.surface.fill.pressed};
      }

      &:disabled {
        background-color: ${(props) => props.theme.cmp.color.ui.avatar.surface.fill.disabled};
      }
    `}

  ${(props) => props.variant === 'logged-out' &&
    css `
      color: ${(props) => props.theme.cmp.color.ui.avatar.foreground.icons.default};

      &:hover:not(:disabled) {
        color: ${(props) => props.theme.cmp.color.ui.avatar.foreground.icons.hover};
      }

      &:active:not(:disabled) {
        color: ${(props) => props.theme.cmp.color.ui.avatar.foreground.icons.pressed};
      }

      &:disabled {
        color: ${(props) => props.theme.cmp.color.ui.avatar.foreground.icons.disabled};
      }
    `}
`;
export const StyledImage = styled.img `
  width: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=index.styles.js.map